import clsx from 'clsx';
import React from "react";
import "./TextArea.css";
import { TextAreaProps } from "./TextArea.types";

const TextArea: React.FC<TextAreaProps> = ({
    ...props
}) => {

    return (
        <div className="flex flex-col gap-1 w-full items-start">
            {
                props.label &&
                <span
                    style={{ fontFamily: "Manrope" }}
                    className={clsx(
                        'text-label-md font-bold text-brandPrimary-800',
                    )}
                >
                    {props.label}
                    {props.required && <span className='text-red-600'> *</span>}
                </span>
            }
            <textarea
                rows={props.rows || 5}
                placeholder={props.placeholder}
                disabled={props.disabled}
                value={props.value}
                defaultValue={props.defaultValue}
                onChange={e => props.onChangeText && props.onChangeText(e.target.value)}
                style={{ fontFamily: "Manrope" }}
                className={clsx(
                    'w-full border rounded-lg px-3.5 py-3 resize-none outline-none transition-colors box-shadow-xs',
                    'text-md text-left text-neutral-700 font-medium',
                    'placeholder:text-md placeholder:text-neutral-500 placeholder:font-medium',
                    'focus:border-brandPrimary-500 focus:ring-1 focus:ring-brandPrimary-500',
                    {
                        'border-neutral-300 bg-white': !props.error && !props.disabled,
                        'border-red-600 bg-white': props.error && !props.disabled,
                        'border-neutral-200 bg-neutral-50 text-neutral-400 cursor-not-allowed': props.disabled,
                    }
                )}
            />
            {
                props.supportingText &&
                <span
                    style={{ fontFamily: "Manrope" }}
                    className={clsx(
                        'text-sm font-medium',
                        {
                            'text-red-500': props.error,
                            'text-neutral-400': !props.error,
                        }
                    )}
                >
                    {props.supportingText}
                </span>
            }
        </div>
    )
};

export default TextArea;